export const FETCHING_BLOCKS = 'FETCHING_BLOCKS';
export const FETCHED_BLOCKS = 'FETCHED_BLOCKS';
export const FETCHED_BLOCKS_BY_TERMS = 'FETCHED_BLOCKS_BY_TERMS';
export const FETCHED_BLOCK = 'FETCHED_BLOCK';
export const CREATED_BLOCK = 'CREATED_BLOCK';
export const UPDATED_BLOCK = 'UPDATED_BLOCK';
export const DELETED_BLOCK = 'DELETED_BLOCK';
export const ENABLED_BLOCK = 'ENABLED_BLOCK';
export const DISABLED_BLOCK = 'DISABLED_BLOCK';

export const SELECT_BLOCK_TYPE = 'SELECT_BLOCK_TYPE';
export const SELECT_BLOCK_DESTINATION = 'SELECT_BLOCK_DESTINATION';
export const SELECT_BLOCK_TRIP_FORMAT = 'SELECT_BLOCK_TRIP_FORMAT';
export const SELECT_BLOCK_TYPE_OF_WORK = 'SELECT_BLOCK_TYPE_OF_WORK';
export const SELECT_BLOCK_NAME = 'SELECT_BLOCK_NAME';
export const SELECT_BLOCK_TITLE = 'SELECT_BLOCK_TITLE';
export const SELECT_BLOCK_BODY = 'SELECT_BLOCK_BODY';
export const SELECT_BLOCK_BUTTON_TEXT = 'SELECT_BLOCK_BUTTON_TEXT';

export const FETCHED_BLOCK_TYPES = 'FETCHED_BLOCK_TYPES';
export const FETCHED_BLOCK_TRANSLATIONS = 'FETCHED_BLOCK_TRANSLATIONS';
export const FETCHED_BLOCK_SITE_TRANSLATION = 'FETCHED_BLOCK_SITE_TRANSLATION';
export const UPDATED_BLOCK_TRANSLATION = 'UPDATED_BLOCK_TRANSLATION';
export const UPDATE_BLOCK_IMAGES_SORT_ORDER = 'UPDATE_BLOCK_IMAGES_SORT_ORDER';
export const DISABLED_TRANSLATION = 'DISABLED_TRANSLATION';
export const ENABLED_TRANSLATION = 'ENABLED_TRANSLATION';
export const DELETED_BLOCK_TRANSLATION = 'DELETED_BLOCK_TRANSLATION';

export const FETCHED_BLOCK_REVISIONS = 'FETCHED_BLOCK_REVISIONS';
export const DELETED_BLOCK_REVISION = 'DELETED_BLOCK_REVISION';
export const FETCHED_TRANSLATION_REVISIONS = 'FETCHED_TRANSLATION_REVISIONS';
export const ACTIVATED_BLOCK_REVISION = 'ACTIVATED_BLOCK_REVISION';
export const ACTIVATED_TRANSLATION_REVISION = 'ACTIVATED_TRANSLATION_REVISION';
export const BLOCK_SEARCH_BY_TITLE = 'BLOCK_SEARCH_BY_TITLE';

export const ADD_IMAGES_IN_BLOCK_EDIT = 'ADD_IMAGES_IN_BLOCK_EDIT';
export const ADD_BLOCK_IMAGE_SETTING = 'ADD_BLOCK_IMAGE_SETTING';
export const ADD_BLOCK_VIDEO_SETTING = 'ADD_BLOCK_VIDEO_SETTING';
export const REMOVE_BLOCK_IMAGE = 'REMOVE_BLOCK_IMAGE';
export const UPDATE_BLOCK_CROPPED_IMAGE = 'UPDATE_BLOCK_CROPPED_IMAGE';
export const UPDATE_BLOCK_IMAGE_META = 'UPDATE_BLOCK_IMAGE_META';
export const UPDATE_BLOCK_THUMB_CROPPED_IMAGE =
    'UPDATE_BLOCK_THUMB_CROPPED_IMAGE';
export const UPDATE_VIDEO_URL_FIELD = 'UPDATE_VIDEO_URL_FIELD';

export const TOGGLE_PAGE_PICKER_POPUP = 'TOGGLE_PAGE_PICKER_POPUP';
export const PICK_BLOCK_PAGE = 'PICK_BLOCK_PAGE';
export const BLOCK_TYPE_ACCREDITATION_ID = 10;



// WEBPACK FOOTER //
// ./src/containers/blocks/types.js